import React from "react";
import { useNavigate } from "react-router-dom";
import certificationCatalog from "../Data/Certdata";
import defaultCert from "../Components/cert.png";

const Certificates = () => {
  const navigate = useNavigate();
  
  // Show only first 9 vendors for the landing page preview
  const previewList = certificationCatalog.slice(0, 9);

  return (
    <section className="px-4 py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto">
        
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6 text-center md:text-left">
          <div className="flex-1">
            <h2 className="text-4xl md:text-6xl font-black text-slate-900 mb-4 tracking-tight">
              TOP VENDORS
            </h2>
            <div className="h-1.5 w-20 bg-[#a300ff] rounded-full mb-6 mx-auto md:mx-0"></div>
            <p className="text-slate-600 text-lg md:text-xl font-medium max-w-2xl leading-relaxed">
              Launch your career with globally recognized credentials from 
              industry-leading technology partners.
            </p>
          </div>
          
          <button 
            onClick={() => navigate('/all-certifications')}
            className="group flex items-center justify-center gap-3 px-8 py-4 bg-white border-2 border-slate-100 text-[#a300ff] font-black text-lg rounded-2xl hover:border-[#a300ff] hover:bg-purple-50 transition-all duration-300 shadow-sm"
          >
            View All 667+ Vendors 
            <span className="group-hover:translate-x-2 transition-transform duration-300">→</span>
          </button>
        </div>

        {/* Grid Display */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {previewList.map((vendor) => (
            <div
              key={vendor.vendorId}
              onClick={() => navigate(`/certificates/${vendor.vendorId}`)}
              className="group relative bg-white p-8 md:p-10 rounded-[3rem] border border-slate-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_20px_40px_rgba(163,0,255,0.1)] transition-all duration-500 cursor-pointer flex flex-col items-center overflow-hidden"
            >
              {/* Decorative accent */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-purple-50/50 rounded-bl-[5rem] -mr-10 -mt-10 group-hover:bg-purple-100 transition-colors duration-500"></div>

              {/* Logo Container */}
              <div className="relative w-24 h-24 mb-8 bg-white p-4 rounded-3xl shadow-inner flex items-center justify-center group-hover:scale-110 group-hover:rotate-3 transition-transform duration-500 ease-out">
                <img
                  src={vendor.vendorLogo || defaultCert}
                  alt={vendor.vendorName}
                  className="w-full h-full object-contain"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = defaultCert;
                  }}
                />
              </div>

              {/* Vendor Info */}
              <h3 className="text-2xl font-bold text-slate-800 text-center group-hover:text-[#a300ff] transition-colors duration-300">
                {vendor.vendorName}
              </h3>
              
              <p className="text-slate-500 text-sm text-center mt-3 line-clamp-2 leading-relaxed font-medium">
                {vendor.vendorDescription}
              </p>

              {/* Badge */}
              <div className="mt-8 flex items-center gap-2 px-5 py-2.5 bg-slate-50 text-[#a300ff] text-xs font-black rounded-full group-hover:bg-[#a300ff] group-hover:text-white transition-all duration-300">
                <span className="text-base">🎓</span>
                {vendor.certifications.length} EXAMS AVAILABLE
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificates;